import React, { createContext, useContext, useState } from 'react';

export const ResellerContext = createContext(null);
export const useReseller = () => useContext(ResellerContext);

export const ResellerProvider = ({ children }) => {
  const [resellers, setResellers] = useState([]);

  const addReseller = (newReseller) => {
    return new Promise((resolve, reject) => {
      try {
        setResellers([...resellers, newReseller]);
        resolve(newReseller);
      } catch (error) {
        reject(error);
      }
    });
  };

  return (
    <ResellerContext.Provider value={{ resellers, addReseller }}>
      {children}
    </ResellerContext.Provider>
  );
};
